export const Logo = ({ dark = false }) => (
  <span className={`inline-flex w-fit items-center ${dark ? "rounded-xl bg-parchment px-3 py-2" : ""}`}>
    <img src="/logo.png" alt="HiPlate" className="h-10 w-auto" />
  </span>
);
